export default {"src":"/_next/static/media/star.042b3c32.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};